module.exports = __webpack_public_path__ + "static/media/Group 754.5600079d.svg";